import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService } from '../services/data.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private dataService: DataService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return combineLatest([this.dataService.selectedOrganizationID$, this.dataService.selectedMemberInfo$]).pipe(
      map(([organizationId, memberInfo]) => {
        if (this.isValidObject(organizationId) && this.isValidObject(memberInfo)) {
          return true;
        }
        console.log('Access denied', 'Please login to continue access');
        return this.router.parseUrl('/login');
      })
    );
  }

  public isValidObject(obj) {
    return !(obj === undefined || obj === null || Object.keys(obj).length === 0);
  }
}
